module.exports = __webpack_public_path__ + "images/bannerPT-ed3418e38beb4736470612929400563c.png";